(function() {
'use strict';

angular
    .module('dashboard')
    .controller('Csr', Csr);

function Csr($routeParams,
             $location,
             $timeout,
             dashboardCsrService,
             dashboardBookingService,
             bookingsManagerService,
             resourceService,
             broker,
             mybTrack) {
    const cm = this;

    cm.bookingId = $routeParams.bookingId;
    cm.getCSRStatus = dashboardCsrService.getCSRStatus;
    cm.getResourceValue = resource => resourceService.get(resource);
    cm.next = next;
    cm.previous = previous;
    cm.createCsr = createCsr;
    cm.currentStep = 2;
    cm.view = view;
    cm.resetCsrForm = resetCsrForm;
    cm.goToCreateCsr = goToCreateCsr;
    cm.CsrFaqCheckEnabled = TRPCONFIG.Domain.CsrFaqCheckEnabled;
    cm.csrCategoryChanged = csrCategoryChanged;
    cm.returnUrl = `/dashboard/csr/${cm.bookingId}`;
    cm.baseUrl = '/dashboard';
    cm.disableFaq = TRPCONFIG.Domain.DisableFAQs;
    cm.isInProgress = false;

    mybTrack.track('MYB - Open CSR');

    function _linkCSR(csrs) {
        cm.csr = csrs;
        cm.allCsr = [...csrs.pending, ...csrs.completed];
    }

    function _rejectCSR() {
        $location.path('dashboard/bookings/current');
    }

    dashboardCsrService.getCSRSummary(cm.bookingId).then(_linkCSR, _rejectCSR);

    dashboardBookingService.getBookingInfo(cm.bookingId).then(function(booking) {
        cm.bk = booking;
        dashboardCsrService.getCsrCategories(booking.Type, cm.bookingId).then(function(categories) {
            cm.csrCategories = categories;
            if (TRPCONFIG.Domain.HideCancelCSRForAutoCancellableBooking) {
                let csrCancelId = TRPCONFIG.Domain.CancelCSRId || 3;
                bookingsManagerService.getCancellationOptions(booking.BookingId).then(booking => {
                    if (booking.CanAutoCancel) {
                        $timeout(() => {
                            cm.csrCategories = _.filter(categories, c => {
                                return c.Id !== csrCancelId;
                            });
                        });
                    }
                });
            }

            if ($routeParams.id) {
                cm.newCsr.Category = _.find(cm.csrCategories, c => c.Id === parseInt($routeParams.id));
                csrCategoryChanged();
            }
        });
        cm.newCsr = {};
        cm.newCsr.TextAlerts = TRPCONFIG.Domain.CsrTextAlertsEnabled;

        cm.childActions = dashboardBookingService.getChildActions(booking.BookingOptions.Actions, 'CSR');
    });

    dashboardBookingService.getContact(cm.bookingId).then(function(contactDetail) {
        cm.ContactDetails = contactDetail.data;
    });


    function resetCsrForm() {
        cm.newCsr = {};
        cm.newCsr.TextAlerts = TRPCONFIG.Domain.CsrTextAlertsEnabled;
    }

    function next() {
        cm.currentStep++;
    }

    function previous() {
        cm.currentStep--;
    }

    function createCsr() {
        cm.isInProgress = true;
        const csrTrackingData = {
            CategoryId: cm.newCsr.Category.Id,
            CategoryText: cm.newCsr.Category.Text,
            TextAlert: !!cm.newCsr.TextAlerts
        };
        mybTrack.track('MYB - CSR', csrTrackingData);
        dashboardCsrService.createCsr(cm.newCsr, cm.bookingId, cm.ContactDetails.MobileTel).then(function(data) {
            //if text alert is selected // update contact details.
            if (cm.newCsr.TextAlerts) {
                dashboardBookingService.putContact(cm.bookingId, cm.ContactDetails).then(() => cm.isInProgress = false);
            } else {
                cm.isInProgress = false;
            }
            cm.newCsr.csrId = data.Id;
            next();
            broker.publish('csrRaised');
            cm.csrCreated = true;
        });
    }

    function view(csr) {
        $location.path(`${cm.baseUrl}/csr-details/${csr.BookingId}/${csr.CsrId}`);
    }

    function goToCreateCsr(couldNotFindAnswer) {
        if (cm.CsrFaqCheckEnabled && !couldNotFindAnswer) {
            return false;
        }
        $location.path(`dashboard/create-csr/${cm.bookingId}`);
    }

    function csrCategoryChanged() {
        cm.newCsr.Subject = cm.newCsr.Category.Text;
    }
}
})();
